import { ApiEndpointClient } from './resource-client';
const TASK_API_PREFIX = 'order-api/v1';
const taskOptions = ({ customerId, ...options } = {}) => ({
    ...options,
    query: customerId ? { customer_uuid: customerId } : {},
});
export class TasksClient extends ApiEndpointClient {
    http;
    constructor(http) {
        super(http, TASK_API_PREFIX);
        this.http = http;
    }
    getTasks = async ({ orderId, customerId, visibility, status }, options) => {
        const query = { sort: '+due_date' };
        if (orderId)
            query.order_uuid = orderId;
        if (customerId)
            query.customer_uuid = customerId;
        if (status)
            query.status = status;
        if (visibility !== undefined)
            query.has_limited_visibility = String(visibility);
        return this.get('/tasks/', { response: 'content-type-or-empty', ...options, query });
    };
    getCustomerTasks = async ({ orderId, status, assignee, assetId, teamId, portfolioId, searchString, sortBy = '+due_date' }, options) => {
        const scoped = taskOptions(options);
        const query = { ...scoped.query, sort: sortBy };
        if (orderId)
            query.order_uuid = orderId;
        if (status)
            query.status = status;
        if (assignee)
            query.assignee = String(assignee);
        if (assetId)
            query.asset_uuid = assetId;
        if (teamId)
            query.team_uuid = teamId;
        if (portfolioId)
            query.portfolio_uuid = portfolioId;
        if (searchString)
            query.search_string = searchString;
        return this.get('/tasks/', { response: 'content-type', ...scoped, query });
    };
    getTask = async ({ taskId }, options) => this.get(`/tasks/${taskId}`, { response: 'content-type-or-empty', ...taskOptions(options) });
    getCustomerTask = async ({ taskId }, options) => this.get(`/tasks/${taskId}`, { response: 'content-type', ...taskOptions(options) });
    patchTask = async ({ taskId, operations }, options) => {
        await this.patch(`/tasks/${taskId}`, { ...taskOptions(options), json: operations, response: 'raw' });
    };
    createTask = async ({ task }, options) => {
        return this.post('/tasks/', { response: 'content-type-or-empty', ...taskOptions(options), json: task });
    };
    createCustomerTask = async ({ task }, options) => {
        return this.post('/tasks/', { response: 'content-type', ...taskOptions(options), json: task });
    };
    deleteTask = async ({ taskId }, options) => {
        return this.delete(`/tasks/${taskId}`, { ...taskOptions(options), response: 'content-type-or-empty' });
    };
    patchCustomerTask = async ({ taskId, operations }, options) => {
        return this.patch(`/tasks/${taskId}`, { ...taskOptions(options), json: operations, response: 'content-type' });
    };
    deleteCustomerTask = async ({ taskId }, options) => {
        return this.delete(`/tasks/${taskId}`, { ...taskOptions(options), response: 'content-type' });
    };
    getTaskChangeLog = async ({ taskId }, options) => this.get(`/tasks/${taskId}/changelog`, { response: 'content-type-or-empty', ...taskOptions(options) });
    getCustomerTaskChangeLog = async ({ taskId }, options) => this.get(`/tasks/${taskId}/changelog`, { response: 'content-type', ...taskOptions(options) });
    uploadTaskDocument = async ({ taskId, document }, options) => {
        const body = new FormData();
        body.append('file', document);
        return this.post(`/tasks/${taskId}/documents`, { response: 'content-type-or-empty', ...taskOptions(options), body });
    };
    uploadCustomerTaskDocument = async ({ taskId, document }, options) => {
        const body = new FormData();
        body.append('file', document);
        return this.post(`/tasks/${taskId}/documents`, { response: 'content-type', ...taskOptions(options), body });
    };
    uploadTaskImage = async ({ taskId, image }, options) => {
        const body = new FormData();
        body.append('file', image);
        return this.post(`/tasks/${taskId}/images`, { response: 'content-type-or-empty', ...taskOptions(options), body });
    };
    uploadCustomerTaskImage = async ({ taskId, image }, options) => {
        const body = new FormData();
        body.append('file', image);
        return this.post(`/tasks/${taskId}/images`, { response: 'content-type', ...taskOptions(options), body });
    };
    getDownloadAllTaskFilesLinkToZip = async ({ taskId }, options) => this.get(`/tasks/${taskId}/files-attachments`, { response: 'content-type-or-empty', ...taskOptions(options) });
    getDownloadAllCustomerTaskFilesLinkToZip = async ({ taskId }, options) => this.get(`/tasks/${taskId}/files-attachments`, { response: 'content-type', ...taskOptions(options) });
}
